module.exports = __webpack_public_path__ + "img/flecie.bb988241.png";